import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Col, Row, Card, Form } from 'react-bootstrap';
import moment from 'moment';
import { useForm } from '../../../hooks/useForm';
import { useGetDta } from '../../../hooks/useGetDta';
import LoadinSpin from '../../ui/LoadinSpin';
import { bytesToSize } from '../../../data/loopMap';
import TraficoUs from './TraficoUs';
const TraficUs = ({ activeTab }) => {
    const { id } = useParams();

    let idR = atob(id);
    let day2 = moment().format('YYYY-MM-DD');
    let day = moment(day2).subtract(2, 'w').format('YYYY-MM-DD');
    const [values, handleInputChange] = useForm({
        fechas: day,
        fechae: day2,
        trafic: 'true',
    });
    const { loading, data, getInfo } = useGetDta(`routeros/truser`, { ...values, idus: idR }, 'PUT');
    const { fechas, fechae, trafic } = values;
    useEffect(() => {
        if (activeTab === 'trafico') getIF();
    }, [fechas, fechae, trafic, idR,activeTab]);

    const getIF = async () => {
        await getInfo(`routeros/truser`, { ...values, idus: idR }, 'PUT');
    };
    if (loading) return <LoadinSpin />;
    return (
        <div className="p-3">
            <Row>
                <Col sm="auto">
                    <Form.Group  controlId="validationCustom022">
                        <Form.Label>Tràfico por</Form.Label>
                        <Form.Select value={values.trafic} name="trafic" required onChange={handleInputChange}>
                            <option value="true">Grafico diario</option>
                            <option value="false">Grafico mensual</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col>
                    <Row>
                        <Col xs="auto">
                            <Form.Group className="mb-3" controlId="validationCustofs">
                                <Form.Label>Fechas</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="fechas"
                                    value={values.fechas}
                                    onChange={handleInputChange}
                                />
                            </Form.Group>{' '}
                        </Col>
                        <Col xs="auto">
                            <Form.Group className="mb-3" controlId="validationCustofe">
                                <Form.Label>al</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="fechae"
                                    value={values.fechae}
                                    onChange={handleInputChange}
                                />
                            </Form.Group>{' '}
                        </Col>
                    </Row>{' '}
                </Col>
                <Col>
                    <Card>
                        <Card.Header className='fs-4 text-primary'>RESUMEN</Card.Header>
                        <Card.Body>
                            {' '}
                            <div className="">
                                <span>Descarga: </span>
                                <span>{bytesToSize(parseInt(data.res.tldn))}</span>
                            </div>
                            <div className="">
                                <span>Subida : </span>
                                <span>{bytesToSize(data.res.tlup)}</span>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>{' '}
            <Col>
                <TraficoUs items={data.apexdata} fechas={data.offsetY} />
            </Col>
        </div>
    );
};

export default TraficUs;
